import ApplicationController from "application_controller.js";

export default class extends ApplicationController {
  static targets = ["title", "subtitle", "description"];

  debug = false;

  connect() {
    this.log_function("connect");

    this.syncToAnchor();
  }

  // * Deep links like #tab3 activate that tab on load (see custom_tabs.js), so the
  // * server-rendered first-tab subtitle and description would be wrong until the next click.
  syncToAnchor(){
    const anchor = (document.URL.split("#").length > 1) ? document.URL.split("#")[1] : null;
    if (!anchor) return;

    const new_subtitle = document.getElementById(anchor)?.dataset?.newSubtitle;
    const new_description = document.getElementById(anchor)?.dataset?.newDescription;

    if (new_subtitle && this.hasSubtitleTarget) this.subtitleTarget.textContent = new_subtitle;
    if (new_description && this.hasDescriptionTarget) this.descriptionTarget.textContent = new_description;
  }

  changeTitle(event){
    this.log_function("changeTitle", event);

    // * check both the element and perent element in case you clicked on the test ot the icon
    const new_title = event.target.dataset.newTitle || event.target.parentElement.dataset.newTitle;

    if (new_title && this.hasTitleTarget) this.titleTarget.textContent = new_title;
  }

  changeSubtitle(event){
    this.log_function("changeSubtitle", event);

    // * check both the element and perent element in case you clicked on the test ot the icon
    const new_subtitle = event.target.dataset.newSubtitle || event.target.parentElement.dataset.newSubtitle;

    if (this.hasSubtitleTarget) this.subtitleTarget.textContent = new_subtitle;
  }

  changeDescription(event){
    this.log_function("changeDescription", event);

    // * check both the element and perent element in case you clicked on the test ot the icon
    const new_description = event.target.dataset.newDescription || event.target.parentElement.dataset.newDescription;

    if (new_description && this.hasDescriptionTarget) this.descriptionTarget.textContent = new_description;
  }

  disconnect(){
    this.log_function("disconnect");
  }
}
